// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack } from '@/components/ui/layout';
import { Title, Text, Button, Anchor, Badge } from '@/components/ui/core';
import { TextInput, PasswordInput, Checkbox } from '@/components/ui/inputs';
import { IconMail, IconLock, IconArrowLeft, IconShield, IconUsers, IconChartBar, IconLayoutSidebar } from '@tabler/icons-react';
import { FadeIn } from '@/components/animations';
import { SidebarLayout, SocialLoginButtons } from '../components';

export default function ResetSidebar() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Login:', { email, password, rememberMe });
  };

  const features = [
    {
      icon: <IconShield size={20} />,
      title: 'Secure & Encrypted',
      description: 'Your data is protected with enterprise-grade security',
    },
    {
      icon: <IconUsers size={20} />,
      title: 'Team Collaboration',
      description: 'Work together seamlessly with your team',
    },
    {
      icon: <IconChartBar size={20} />,
      title: 'Advanced Analytics',
      description: 'Get insights with powerful reporting tools',
    },
  ];

  return (
    <SidebarLayout
      logo={
        <Badge size="xl" variant="white" leftSection={<IconLayoutSidebar size={16} />}>
          YourApp
        </Badge>
      }
      title="Welcome Back"
      subtitle="Access your account and continue where you left off"
      features={features}
      showFeatures={true}
    >
      <Stack gap="lg" style={{ maxWidth: 400, width: '100%' }}>
        <FadeIn>
          <Stack gap="xs">
            <Button
              component={Link}
              to="/app/demo/auth-pages/reset-password"
              variant="subtle"
              size="xs"
              leftSection={<IconArrowLeft size={14} />}
              w="fit-content"
            >
              Back to variants
            </Button>
            <Title order={2}>Sign in</Title>
            <Text c="dimmed" size="sm">
              Enter your credentials to access your account
            </Text>
          </Stack>
        </FadeIn>

        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <TextInput
              label="Email"
              placeholder="you@example.com"
              leftSection={<IconMail size={16} />}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <PasswordInput
              label="Password"
              placeholder="Your password"
              leftSection={<IconLock size={16} />}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <Checkbox
              label="Remember me"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.currentTarget.checked)}
            />

            <Button type="submit" fullWidth size="md" variant="gradient" gradient={{ from: 'indigo', to: 'cyan' }}>
              Sign in
            </Button>
          </Stack>
        </form>

        <Stack gap="md">
          <Text ta="center" size="sm" c="dimmed">
            Or continue with
          </Text>
          <SocialLoginButtons providers={['google', 'github']} layout="row" />
        </Stack>

        <Stack gap="xs" align="center">
          <Anchor component={Link} to="/app/demo/auth-pages/forgot-password/sidebar" size="sm">
            Forgot your password?
          </Anchor>
          <Text size="sm" c="dimmed">
            Don't have an account?{' '}
            <Anchor component={Link} to="/app/demo/auth-pages/register/sidebar" fw={500}>
              Sign up
            </Anchor>
          </Text>
        </Stack>
      </Stack>
    </SidebarLayout>
  );
}
